export { default } from 'jsonwebtoken/decode'
